import SafeHtmlParser from '../../Global/SafeHTMLParser';
import { cn } from '@/lib/utils';

export interface FlashcardFaceProps {
  html: string;
  face: 'front' | 'back';
  onError?: () => void;
  className?: string;
}

const ignoreParseError = () => undefined;

/**
 * Shared flashcard face markup for study sessions and in-chat decks. The face
 * carries its own modifier class (`flashcard_face--front|back`) so the cloze
 * and the front-face keyword gate style the same everywhere; the session's
 * flip classes (`flashcard_front` / `flashcard_back`) come in through
 * `className`, because a deck that shows one face at a time must not inherit
 * `display: none` from the flip.
 */
const FlashcardFace = ({
  html,
  face,
  onError = ignoreParseError,
  className,
}: FlashcardFaceProps) => (
  <div
    className={cn('flashcard_face', `flashcard_face--${face}`, className)}
    data-explainers-disabled={face === 'front' ? 'true' : undefined}
  >
    <SafeHtmlParser
      html={html}
      onError={onError}
      fallbackText="Error loading flashcard content"
    />
  </div>
);

export default FlashcardFace;
